import { BefConfigContext, BefGlobalContext } from "@beflam/bef-core";
import { useContext, useEffect, useState } from "react";

export function AppFooter(prop: any) {
    const sConfig = useContext(BefConfigContext);
    const sGlobal = useContext(BefGlobalContext);
    const [serverVersion, setServerVersion] = useState<string>(sGlobal.serverVersion);

    useEffect(() => {
        const initEventSub = sConfig.initEvent.subscribe(async (result: any) => {
            setServerVersion(sGlobal.serverVersion);
        });
        return () => {
            initEventSub.unsubscribe();
        }
    }, []);
    return (
        <div className="footer">
            <div className="pull-left" >
                <strong>Powered by Beflam.com v{serverVersion}</strong>
            </div>
        </div>
    );
}